import "leaflet/dist/leaflet.css";
import { Marker, Popup, TileLayer, useMap, MapContainer as LeafletMapContainer, Tooltip } from "react-leaflet";
import L from "leaflet";
import { getStationLogo } from "../utils/index";
import { StationCard } from "../components/StationCard";
import haversineDistance from "haversine-distance";
import { useEffect, useState } from "react";

const useDevice = () => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);

  return {
    isMobile: width <= 768
  }
}

const MapEvents = ({ setMapZoom, setMapCenter, setMapRadius }) => {
  const map = useMap();

  const calculateMapRadius = () => {
    const bounds = map.getBounds();
    const north = bounds.getNorth();
    const east = bounds.getEast();
    const south = bounds.getSouth();
    const west = bounds.getWest();

    const width = haversineDistance([north, east], [north, west]);
    const height = haversineDistance([north, 0], [south, 0]);

    const radius = Math.sqrt(Math.pow(width / 2, 2), Math.pow(height / 2, 2));

    return radius;
  }

  map.addEventListener("zoomend", e => {
    setMapZoom(map.getZoom());
  });

  map.addEventListener("moveend", e => {
    const center = map.getCenter();
    setMapCenter([center.lat, center.lng]);

    const radius = calculateMapRadius();
    setMapRadius(radius);
  });

  return null;
}


export const MapContainer = ({
  stations = [],
  mapZoom = 6,
  mapCenter,
  setMapZoom = (value) => { },
  setMapCenter = (value) => { },
  setMapRadius = (value) => { },
}) => {
  const { isMobile } = useDevice();

  return <LeafletMapContainer
    preferCanvas={true}
    center={mapCenter}
    zoom={mapZoom}
    className="w-full h-[75vh] md:h-[60vh]"
    tap={false}
  >
    <MapEvents
      setMapZoom={setMapZoom}
      setMapCenter={setMapCenter}
      setMapRadius={setMapRadius}
    />

    <TileLayer
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />

    {stations.map(station => <Marker
      key={station.station_id}
      position={[station.latitude, station.longitude]}
      icon={new L.Icon({
        iconUrl: getStationLogo(station.name),
        iconSize: new L.Point(2 * mapZoom, 2 * mapZoom),
        className: "leaflet-div-icon",
      })}
    >
      <Popup minWidth={isMobile ? 200 : 400}>
        <StationCard
          station={station}
          showHistoryChart={true}
          isMobile={isMobile}
        />
      </Popup>
      {mapZoom > 15 && station.price_gasoline_95_e5 && station.price_diesel_a && <Tooltip
        direction="bottom"
        offset={[0, 10]}
        opacity={1}
        permanent
      >
        <div>G: {station.price_gasoline_95_e5} €</div>
        <div>D: {station.price_diesel_a} €</div>
      </Tooltip>}
    </Marker>)}
  </LeafletMapContainer>
}